<div class="payment-status-indicator">
  <div class="indicator" [ngClass]="(status === 'LIVE') ? 'active' : (status === 'TEST') ? 'inactive' :  'canceled'">
  </div>
</div>
